import React, { useEffect, useState } from 'react';
import './main-game.css';
import { goToScreen, goToScreenAndReset } from '../../actions/router';
import { connect } from 'react-redux';
import {
    MAIN_GAME_SCREEN,
    SETTINGS_SCREEN,
    TIME_PASSING_SCREEN,
    TITLE_SCREEN,
} from '../../constants/routes';
import { ProgressUpdate } from '../../components/progress-update';
import { IconButton } from '../../components/icon-button';
import { TabMenu } from '../../components/tab-menu';
import { Panel } from '../../components/panel';
import { Heading } from '../../components/heading';
import {
    removePhoneCall,
    exitGame,
    setCurrentPhoneCall,
} from '../../actions/active-game';
import { PhoneCallModalParent } from '../../components/modal-parents/phone-call-modal';
import classNames from 'classnames';
import { days, times } from '../../helpers/time';

const MainGameScreen = props => {
    const {
        goToScreen,
        currentDay,
        currentTime,
        currentCall,
        incomingCallInfo,
        initiatePhoneCall,
        removePhoneCallFromCalendar,
        initiateEndOfDay,
        currentMessages,
        currentMeetings,
        overallScores,
        audioIsOn,
        failThreshold,
        party,
        exitCall,
    } = props;

    useEffect(() => {
        if (
            overallScores.party + overallScores.media + overallScores.voters <
            failThreshold
        ) {
            const phoneCallId =
                party === 'government' ? 'call_gfailed' : 'call_ofailed';
            initiatePhoneCall(phoneCallId);
            setIncomingCall(true);
        }
    }, [failThreshold, initiatePhoneCall, overallScores, party]);

    const shouldCallSoon =
        incomingCallInfo && incomingCallInfo.timeslot === currentTime;

    const [incomingCall, setIncomingCall] = useState(false);
    const [dayIsEnding, setDayIsEnding] = useState(false);

    useEffect(() => {
        let callTimeout = null;
        if (incomingCallInfo && shouldCallSoon && currentCall === null) {
            callTimeout = setTimeout(() => {
                initiatePhoneCall(incomingCallInfo.phone_callID);
                setIncomingCall(true);
            }, 600);
        }
        let endOfDayTimeout = null;
        let endOfDayTransitionTimeout = null;
        if (currentTime === 6) {
            endOfDayTransitionTimeout = setTimeout(
                () => setDayIsEnding(true),
                200,
            );
            endOfDayTimeout = setTimeout(() => {
                initiateEndOfDay();
            }, 1000);
        }

        return () => {
            clearTimeout(callTimeout);
            clearTimeout(endOfDayTimeout);
            clearTimeout(endOfDayTransitionTimeout);
        };
    }, [
        currentCall,
        currentTime,
        incomingCallInfo,
        initiateEndOfDay,
        initiatePhoneCall,
        shouldCallSoon,
    ]);

    const modalVisible = currentCall !== null || incomingCall;

    const mainPageClasses = classNames({
        'main-game': true,
        'main-game--hidden': modalVisible || dayIsEnding,
        'main-game--end-of-day': dayIsEnding,
    });

    const time = times[currentTime];
    const day = days[currentDay];

    return (
        <>
            <div className={mainPageClasses} aria-hidden={modalVisible}>
                <div className="main-game__progress-update">
                    <div
                        className="main-game__icon-placeholder"
                        aria-hidden={true}
                    />
                    <Panel
                        flexDirection="column"
                        color="less-opacity-white"
                        currentPage="main game screen progress update"
                    >
                        <div>
                            <Heading
                                headingType="h3"
                                colorScheme="dark"
                                withSpacing={false}
                            >
                                {day} {time}
                            </Heading>
                        </div>
                        <ProgressUpdate
                            updatedScores={overallScores}
                            ariaHideTeardrops={currentCall !== null}
                        />
                    </Panel>
                    <IconButton
                        iconName="settings"
                        type="essential"
                        size="small"
                        onClick={() => goToScreen(SETTINGS_SCREEN)}
                        withSpacing={true}
                        isDisabled={modalVisible}
                    />
                </div>
                <TabMenu
                    screen={MAIN_GAME_SCREEN}
                    currentDay={currentDay}
                    shouldBeUninteractable={
                        shouldCallSoon || currentTime === 6 || modalVisible
                    }
                    messagesNotifications={currentMessages.length}
                    meetingsNotifications={currentMeetings.length}
                />
            </div>
            {currentCall && incomingCall === true && (
                <PhoneCallModalParent
                    currentCall={currentCall}
                    goToScreen={route => {
                        goToScreen(route);
                    }}
                    exitCall={route => exitCall(route)}
                    removePhoneCall={() => {
                        setIncomingCall(false);
                        removePhoneCallFromCalendar(currentCall.phone_callID);
                    }}
                    audioIsOn={audioIsOn}
                />
            )}
        </>
    );
};

const mapStateToProps = state => {
    return {
        currentDay: state.activeGame.currentDay,
        currentTime: state.activeGame.currentTime,
        incomingCallInfo:
            state.activeGame.calendar[state.activeGame.currentDay].call[0] ??
            null,
        currentCall: state.activeGame.currentCall,
        currentMessages: state.activeGame.currentMessages,
        currentMeetings: state.activeGame.currentMeetings,
        overallScores: state.activeGame.overallScores,
        audioIsOn: state.settings.audio,
        failThreshold: state.settings.gameSettings.failThreshold,
        party: state.settings.gameSettings.party,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        goToScreen: route => {
            dispatch(goToScreen(route));
        },
        exitCall: route => {
            if (route === TITLE_SCREEN) {
                dispatch(exitGame());
            }
            dispatch(goToScreenAndReset(route));
        },
        initiatePhoneCall: callDetails => {
            dispatch(setCurrentPhoneCall(callDetails));
        },
        removePhoneCallFromCalendar: phoneCallId => {
            dispatch(removePhoneCall(phoneCallId));
        },
        initiateEndOfDay: () => {
            dispatch(goToScreen(TIME_PASSING_SCREEN));
        },
    };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(MainGameScreen);
export { connected as MainGameScreen };
